import { useNavigate, useParams } from "react-router-dom";
import DiagnosisSummaryCard from "../components/diagnoses/diagnosis-summary-card";
// import RecordImageUpload from "../components/medical-records/record-image-upload";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import UploadDocumentButton from "../components/content/create-content-button";
import AddDiagnosisModal from "../components/diagnoses/add-diagnosis-modal";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadDiagnoses from "../hooks/useLoadDiagnoses";
import { buildRecordDetailPath } from "#/lib/medicalRecords";

const DiagnosesPage = () => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();
  const { diagnoses, isLoading, error } = useLoadDiagnoses(userId);
  const list = Array.isArray(diagnoses) ? diagnoses : [];
  useSetPageContext(list);
  const [isAddOpen, setIsAddOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta">
          Failed to load diagnoses
        </Typography>
      </div>
    );
  }

  const hasDiagnoses = list.length > 0;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-10 flex flex-wrap justify-end gap-4">
        <button
          className="flex items-center gap-2"
          onClick={() => setIsAddOpen(true)}
        >
          <PlusCircleIcon className="w-5 h-5 text-terracotta-500 transition-colors" />
          <Typography variant="body1" className="text-terracotta">
            Add Diagnosis
          </Typography>
        </button>
        <UploadDocumentButton />
      </div>
      {!hasDiagnoses && (
        <div className="mt-4 flex flex-col items-center justify-center gap-4 text-center">
          <Typography variant="h4" className="text-terracotta">
            No diagnoses listed.
          </Typography>
          <Typography variant="body1" className="text-terracotta">
            To add a diagnosis take a photo or ask the chat below to add it.
          </Typography>
        </div>
      )}
      <div className="grid gap-4">
        {hasDiagnoses
          ? list.map((d) => (
              <div
                key={d.id}
                id={`record-diagnosis-${d.id}`}
                className="file-record-anchor block scroll-mt-24"
              >
                <DiagnosisSummaryCard
                  diagnosis={d}
                  onClick={() => {
                    const detailPath = buildRecordDetailPath(
                      "diagnoses",
                      d.id,
                      userId
                    );
                    if (!detailPath) return;
                    navigate(detailPath, { state: { record: d } });
                  }}
                />
              </div>
            ))
          : null}
      </div>

      <AddDiagnosisModal
        userId={userId}
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
      />
    </div>
  );
};

export default DiagnosesPage;
